import {Navigation} from 'swiper';
import {swiperOnResize} from '../../utils/swiperOnResize.utils.js';

const initializedWrappers = new WeakSet();

const initHomeTeamSwiper = (scope = document) => {
    scope.querySelectorAll('.team-home-swiper-wr').forEach((wrapper) => {
        if (initializedWrappers.has(wrapper)) {
            return;
        }

        const swiperEl = wrapper.querySelector('.swiper');
        const slidesCount = swiperEl?.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length ?? 0;

        if (!swiperEl || !slidesCount) {
            return;
        }

        const nextEl = wrapper.querySelector('.swiper-button-next');
        const prevEl = wrapper.querySelector('.swiper-button-prev');

        swiperOnResize('(max-width: 640px)', swiperEl, {
            modules: [Navigation],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            navigation: nextEl && prevEl ? {
                nextEl,
                prevEl,
            } : undefined,
        });

        initializedWrappers.add(wrapper);
    });
};

initHomeTeamSwiper();
window.initHomeTeamSwiper = initHomeTeamSwiper;
